<svg class="decline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
  <circle class="decline__circle" cx="26" cy="26" r="25" fill="none" />
  <path class="decline__line" fill="none" d="M17.6,34.4l16.7-16.8" />
  <path class="decline__line" fill="none" d="M17.6,17.6l16.8,16.7" />
</svg>
